module.exports = __webpack_public_path__ + "static/media/icon.66aa496e.svg";